import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Layout from "../Common/Layout";
import Swal from "sweetalert2";



const DoForm = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const RequiredStar = () => (
    <span style={{ color: "red", marginLeft: "4px" }}>*</span>
  );

  const [crdData, setCrdData] = useState([]);

  const [showModal, setShowModal] = useState(false);

  const [warehouses, setWarehouses] = useState([]);
  const [loadingWarehouses, setLoadingWarehouses] = useState(false);

  const [varieties, setVarieties] = useState([]);
  const [loadingVarieties, setLoadingVarieties] = useState(false);

  const getTodayDate = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const [clients, setClients] = useState([]);
  const [loadingClients, setLoadingClients] = useState(false);

  useEffect(() => {
    fetchClients();
    fetchWarehouses();
    fetchVarieties(); // ✅ NEW
  }, []);

  const fetchClients = async () => {
    try {
      setLoadingClients(true);

      const token = sessionStorage.getItem("token");

      const res = await axios.get(
        "https://irc.zentelex.com/api/master-client/getclients",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setClients(res.data.data || []);
    } catch (err) {
      console.error("Failed to load clients", err);
      alert(err.response?.data?.message || "Failed to load clients");
    } finally {
      setLoadingClients(false);
    }
  };

  const filteredClients = clients.filter((client) => {
    const search = searchTerm.toLowerCase();

    return (
      client.company_name?.toLowerCase().includes(search) ||
      client.name?.toLowerCase().includes(search) ||
      client.product?.toLowerCase().includes(search) ||
      client.cargo_type?.toLowerCase().includes(search) ||
      client.variety?.toLowerCase().includes(search) ||
      client.warehouse?.toLowerCase().includes(search) ||
      client.bl_vessel_no?.toLowerCase().includes(search)
    );
  });

  console.log(clients);

  const fetchVarieties = async () => {
    try {
      setLoadingVarieties(true);

      const token = sessionStorage.getItem("token");

      const res = await axios.get(
        "https://irc.zentelex.com/api/varieties/dropdown",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      console.log("VARIETIES:", res.data); // 🔍 debug
      setVarieties(res.data || []);
    } catch (err) {
      console.error("Failed to load varieties", err);
      alert(err.response?.data?.message || "Failed to load varieties");
    } finally {
      setLoadingVarieties(false);
    }
  };

  const fetchWarehouses = async () => {
    try {
      setLoadingWarehouses(true);

      const token = sessionStorage.getItem("token");

      const res = await axios.get(
        "https://irc.zentelex.com/api/warehouses/dropdown",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      console.log("WAREHOUSES:", res.data); // 🔍 debug

      setWarehouses(res.data || []); // ✅ FIX HERE
    } catch (err) {
      console.error("Failed to load warehouses", err);
      alert(err.response?.data?.message || "Failed to load warehouses");
    } finally {
      setLoadingWarehouses(false);
    }
  };

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    crd: "",
    clientName: "",
    contactNo: "",
    cargo_type: "",
    date: getTodayDate(),
    doValidityTill: getTodayDate(),
    variety: "", // ✅ NEW
    bl_vessel_no: "",
    stack: "",

    mainImporter: "",
    buyer: "",
    buyerAddress: "",
    gstNo: "",
    broker: "",
    commodity: "",
    doQuantity: "",
    packing: "",
    warehouse: "",
    warehouseAddress: "", // ✅ ADD
    labourContractorName: "",
    clientAddress: "",
    weighBridgeName: "", // 🔥 NEW

    cha: "",
    chaContactPerson: "",
    surveyor: "",
    surveyorContactPerson: "",
    transporter: "",
  });

  const fetchCommodityReceipt = async () => {
    try {
      const token = sessionStorage.getItem("token");

      const res = await axios.get(
        `https://irc.zentelex.com/api/commodity-receipts/commodity-receipt/crd/${formData.crd}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = res.data.data; // array

      console.log("CRD Data:", data);

      // ✅ Get stackNo (single record)
      if (data && data.length > 0) {
        const stackNo = data[0].stackNo;

        console.log("Stack No:", stackNo);

        // ✅ Store in sessionStorage

        setFormData((prev) => ({
          ...prev,

          stack: stackNo,
        }));
        sessionStorage.setItem("stackNo", stackNo);
      }

      return data; // ✅ return actual data
    } catch (error) {
      console.error("Error fetching CRD data:", error);
    }
  };

  useEffect(() => {
    if (formData.crd) {
      fetchCommodityReceipt(formData.crd).then((data) => {
        setCrdData(data || []);
      });
    }
  }, [formData.crd]);

  const fetchContainerNoByCrd = async (crdNo) => {
    try {
      const token = sessionStorage.getItem("token");

      const res = await axios.get(
        `https://irc.zentelex.com/api/kataslip/kataslip/crd/${crdNo}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = res.data.data;

      console.log("KataSlip Data:", data);

      // ✅ If data exists
      if (Array.isArray(data) && data.length > 0) {
        const containerNo = data[0].containerNo; // 👈 get first container no

        if (containerNo) {
          sessionStorage.setItem("containerNo", containerNo);
          console.log("Saved containerNo:", containerNo);
        }
      }

      return data;
    } catch (error) {
      console.error("Error fetching containerNo:", error);
    }
  };

  useEffect(() => {
    if (formData.crd) {
      fetchContainerNoByCrd(formData.crd);
    }
  }, [formData.crd]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      // Warehouse selection logic
      if (name === "warehouse") {
        const selected = warehouses.find((w) => w.name === value);

        return {
          ...prev,
          warehouse: value,
          warehouseAddress: selected ? selected.address || "" : "",
          labourContractorName: selected ? selected.labourContractor || "" : "",
        };
      }

      // Custom warehouse input
      if (name === "customWarehouse") {
        return {
          ...prev,
          customWarehouse: value,
          warehouse: value, // ✅ store real warehouse name
        };
      }

      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 🔔 Beautiful confirmation popup
    const result = await Swal.fire({
      title: "Create Delivery Order?",
      text: "Please confirm you want to create this Delivery Order.",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#EC662C", // your theme orange
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Create",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });

    // ❌ If user cancels
    if (!result.isConfirmed) {
      return;
    }

    const token = sessionStorage.getItem("token");

    const payload = {
      clientName: formData.clientName,
      contactNo: formData.contactNo,
      cargo_type: formData.cargo_type,
      date: formData.date,
      doValidityTill: formData.doValidityTill,
      variety: formData.variety,
      stack: formData.stack,

      bl_vessel_no: formData.bl_vessel_no,
      mainImporter: formData.mainImporter,
      buyer: formData.buyer,
      buyerAddress: formData.buyerAddress,
      gstNo: formData.gstNo,
      broker: formData.broker,
      commodity: formData.commodity,

      doQuantity: formData.doQuantity ? parseFloat(formData.doQuantity) : null,

      packing: formData.packing,
      warehouse: formData.warehouse,
      warehouseAddress: formData.warehouseAddress,
      weighBridgeName: formData.weighBridgeName,

      cha: formData.cha,
      chaContactPerson: formData.chaContactPerson,
      surveyor: formData.surveyor,
      surveyorContactPerson: formData.surveyorContactPerson,
      transporter: formData.transporter,

      clientAddress: formData.clientAddress,

      // 🔴 IMPORTANT — send correct key name
      labourContractorName: formData.labourContractorName,

      created_by: sessionStorage.getItem("userId"),
    };

    console.log("FINAL PAYLOAD 👉", payload);

    try {
      const response = await axios.post(
        "https://irc.zentelex.com/api/delivery-orders",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      alert("Delivery Order Created Successfully!");
      console.log("CDD No:", response.data.data.cddNo);

      sessionStorage.setItem(
        "deliveryorder",
        JSON.stringify(response.data.data),
      );

      navigate("/outbound-gateway-entry");
    } catch (error) {
      console.error(error);
      alert(error.response?.data?.message || "Failed to create Delivery Order");
    }
  };

  const fetchInboundQty = async (data) => {
    try {
      const token = sessionStorage.getItem("token");

      const res = await axios.get(
        "https://irc.zentelex.com/api/kataslip/inbound-total-qty",
        {
          params: {
            companyName: data.company_name,
            product: data.product,
            variety: data.variety,
            warehouse: data.warehouse,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      return res.data.data?.totalQuantity || 0;
    } catch (error) {
      console.error("Error fetching inbound qty:", error);
      return 0;
    }
  };

  const handleSelectClient = async (item) => {
    setFormData((prev) => ({
      ...prev,
      crd: item.crdNo || "",
      clientName: item.company_name || "",
      contactNo: item.contact_number || "",
      cargo_type: item.cargo_type || "",
      variety: item.variety || "",
      commodity: item.product || "",
      warehouse: item.warehouse || "",
      warehouseAddress: item.warehouse_address || "",
      bl_vessel_no: item.bl_vessel_no || "",
      labourContractorName: item.labourContractor || "",
      clientAddress: item.address || "",
      stack: item.stackNo || "",
      mainImporter: item.company_name || "",
    }));

    // ✅ CALL API
    const totalInbound = await fetchInboundQty(item);

    // ✅ SHOW IN TOAST
    Swal.fire({
      icon: "info",
      title: "Inbound Quantity",
      text: `Total Inbound: ${totalInbound} MT`,
      confirmButtonColor: "#EC662C",
    });
  };

  console.log(formData);

  const handleViewClient = async (client) => {
    handleSelectClient(client);

    if (client.crdNo) {
      const data = await fetchCommodityReceipt(client.crdNo);
      setCrdData(data || []);
    }

    setShowModal(true);
  };

  console.log(crdData);

  return (
    <>
      {/* ================= MODAL ================= */}
      {showModal && (
        <>
          <div
            className="modal fade show d-block"
            tabIndex="-1"
            style={{ zIndex: 1055 }}
          >
            <div className="modal-dialog modal-xl modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">CRD Details</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                  ></button>
                </div>

                <div className="modal-body">
                  {crdData.length === 0 ? (
                    <p className="text-muted">No data found for this CRD.</p>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped table-sm">
                        <thead className="table-dark text-center">
                          <tr>
                            <th>#</th>
                            <th>CRD No</th>
                            <th>Product</th>
                            <th>Cargo Type</th>
                            <th>Variety</th>
                            <th>Warehouse</th>
                            <th>Stack</th>
                            <th>Company</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {crdData.map((item, index) => (
                            <tr key={item.id || index}>
                              <td>{index + 1}</td>
                              <td>{item.crdNo}</td>
                              <td>{item.commodityName}</td> {/* ✅ FIX */}
                              <td>{item.cargo_type}</td>
                              <td>{item.variety}</td>
                              <td>{item.warehouseName}</td>
                              <td>{item.stackNo}</td>{" "}
                              {/* ✅ instead of stackNo */}
                              <td>{item.clientName}</td> {/* ✅ FIX */}
                              <td>
                                <span className="badge bg-warning text-dark">
                                  {item.status}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* ✅ Backdrop OUTSIDE modal */}
          <div
            className="modal-backdrop fade show"
            style={{ zIndex: 1050 }}
          ></div>
        </>
      )}

      {/* ================= MODAL END ================= */}

      <Layout>
        <div className="content-page">
          <div className="content">
            <div className="container py-4">
              {/* 🔹 CLIENT MASTER LIST */}
              {/* Clients Master Table */}
              <div className="card mb-4 shadow-sm">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <span className="fw-semibold">Client Master List</span>

                  <input
                    type="text"
                    placeholder="Search client..."
                    className="form-control form-control-sm"
                    style={{ width: "250px" }}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>

                <div className="card-body p-0">
                  {loadingClients ? (
                    <div className="p-3 text-warning">Loading clients...</div>
                  ) : filteredClients.length === 0 ? (
                    <div className="p-3 text-muted">No clients found</div>
                  ) : (
                    <div style={{ maxHeight: "250px", overflowY: "auto" }}>
                      <table className="table table-bordered table-hover table-sm mb-0">
                        <thead className="table-light text-center">
                          <tr>
                            <th>#</th>
                            <th>Client Name</th>
                            <th>Product</th>
                            <th>Cargo Type</th>
                            <th>Variety</th>
                            <th>Warehouse</th>
                            <th>BL/Vessel no </th>
                            <th>Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          {filteredClients.map((client, index) => (
                            <tr key={client.id || index}>
                              <td className="text-center">{index + 1}</td>
                              <td>{client.company_name || client.name}</td>
                              <td>{client.product}</td> {/* ✅ FIX */}
                              <td>{client.cargo_type}</td>
                              <td>{client.variety}</td>
                              <td>{client.warehouse}</td>
                              <td>{client.bl_vessel_no}</td>
                              <td className="text-center">
                                <button
                                  className="btn btn-sm btn-primary"
                                  onClick={() => handleViewClient(client)}
                                >
                                  View
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>

              <div
                className="card shadow-sm mx-auto"
                style={{ maxWidth: "900px" }}
              >
                <div className="card-header fw-semibold">
                  Delivery Order Form
                </div>
                <div
                  className="card-body"
                  style={{ backgroundColor: "#3075A6" }}
                >
                  <form onSubmit={handleSubmit}>
                    <div className="row g-4">
                      <div className="col-md-4">
                        <label
                          className="form-label"
                          style={{ color: "white" }}
                        >
                          Client Name
                          <RequiredStar />
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="clientName"
                          value={formData.clientName}
                          onChange={handleChange}
                          required
                          readOnly
                        />
                      </div>
                      <div className="col-md-4">
                        <label
                          className="form-label"
                          style={{ color: "white" }}
                        >
                          Contact No
                          <RequiredStar />
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="contactNo"
                          value={formData.contactNo}
                          onChange={handleChange}
                          required
                          readOnly
                        />
                      </div>
                      <div className="col-md-4">
                        <label
                          className="form-label fw-semibold"
                          style={{ color: "white" }}
                        >
                          Cargo Type
                          <RequiredStar />
                        </label>

                        <input
                          type="text"
                          className="form-control"
                          name="cargo_type" // ✅ REQUIRED
                          value={formData.cargo_type}
                          onChange={handleChange}
                          required
                          readOnly
                        />
                      </div>
                    </div>

                    <div className="row g-4 mt-1">
                      <div className="col-md-4">
                        <label
                          className="form-label"
                          style={{ color: "white" }}
                        >
                          Date
                          <RequiredStar />
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          name="date"
                          value={formData.date}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-4">
                        <label
                          className="form-label"
                          style={{ color: "white" }}
                        >
                          DO Validity Till
                          <RequiredStar />
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          name="doValidityTill"
                          value={formData.doValidityTill}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-4">
                        <label
                          className="form-label"
                          style={{ color: "white" }}
                        >
                          Weigh Bridge Name
                          <RequiredStar />
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="weighBridgeName"
                          value={formData.weighBridgeName}
                          onChange={handleChange}
                          placeholder="Enter weigh bridge name"
                        />
                      </div>
                    </div>

                    <div className="row g-4 mt-1">
                      <div className="col-md-4">
                        <label
                          className="form-label"
                          style={{ color: "white" }}
                        >
                          BL No/Vessel Name
                          <RequiredStar />
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="bl_vessel_no"
                          value={formData.bl_vessel_no}
                          onChange={handleChange}
                          readOnly
                        />
                      </div>
                      <div className="col-md-4">
                        <label
                          className="form-label"
                          style={{ color: "white" }}
                        >
                          Main Importer
                          <RequiredStar />
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="mainImporter"
                          value={formData.mainImporter}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-md-4">
                        <label
                          className="form-label"
                          style={{ color: "white" }}
                        >
                          Buyer
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="buyer"
                          value={formData.buyer}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="row g-4 mt-1">
                      <div className="col-12">
                        <label
                          className="form-label"
                          style={{ color: "white" }}
                        >
                          Buyer Address
                        </label>
                        <textarea
                          className="form-control"
                          rows="3"
                          name="buyerAddress"
                          value={formData.buyerAddress}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label fw-semibold"
                          style={{ color: "white" }}
                        >
                          Warehouse
                          <RequiredStar />
                        </label>

                        <input
                          type="text"
                          className="form-control"
                          name="warehouse"
                          value={formData.warehouse}
                          onChange={handleChange}
                          required
                          readOnly // ✅ use readOnly instead of disabled (better for form submit)
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label fw-semibold"
                          style={{ color: "white" }}
                        >
                          Warehouse Address
                          <RequiredStar />
                        </label>

                        <textarea
                          className="form-control"
                          id="warehouseAddress"
                          value={formData.warehouseAddress}
                          readOnly
                          rows={3}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label text-white fw-semibold">
                          Labour Contractor Name
                          <RequiredStar />
                        </label>
                        <input
                          type="text"
                          name="labourContractorName"
                          value={formData.labourContractorName}
                          onChange={handleChange}
                          className="form-control"
                          readOnly
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label text-white fw-semibold">
                          Client Address
                          <RequiredStar />
                        </label>
                        <input
                          type="text"
                          name="clientAddress"
                          value={formData.clientAddress}
                          onChange={handleChange}
                          className="form-control"
                          readOnly
                        />
                      </div>
                    </div>

                    <div className="row g-4 mt-1">
                      <div className="col-md-3">
                        <label
                          className="form-label"
                          style={{ color: "white" }}
                        >
                          GST No
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="gstNo"
                          value={formData.gstNo}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-md-3">
                        <label
                          className="form-label fw-semibold"
                          style={{ color: "white" }}
                        >
                          Variety
                          <RequiredStar />
                        </label>

                        <input
                          type="text"
                          className="form-control"
                          id="variety"
                          name="variety"
                          value={formData.variety}
                          onChange={handleChange}
                          required
                          readOnly // ✅ better than disabled
                        />
                      </div>
                      <div className="col-md-3">
                        <label
                          className="form-label"
                          style={{ color: "white" }}
                        >
                          Broker
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="broker"
                          value={formData.broker}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-md-3">
                        <label
                          className="form-label"
                          style={{ color: "white" }}
                        >
                          Commodity
                          <RequiredStar />
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="commodity"
                          value={formData.commodity}
                          onChange={handleChange}
                          readOnly
                        />
                      </div>
                    </div>
                    <br />

                    <div className="row">
                      <div className="col-md-3">
                        <label
                          className="form-label"
                          style={{ color: "white" }}
                        >
                          DO Quantity (MT)
                          <RequiredStar />
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="doQuantity"
                          value={formData.doQuantity}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-md-3">
                        <label
                          className="form-label"
                          style={{ color: "white" }}
                        >
                          stack
                          <RequiredStar />
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="stack"
                          value={formData.stack}
                          onChange={handleChange}
                          readOnly
                        />
                      </div>
                    </div>

                    <div className="row g-4 mt-1">
                      <div className="col-md-3">
                        <label
                          className="form-label"
                          style={{ color: "white" }}
                        >
                          Packing
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="packing"
                          value={formData.packing}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-md-3">
                        <label
                          className="form-label"
                          style={{ color: "white" }}
                        >
                          CHA
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="cha"
                          value={formData.cha}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-md-3">
                        <label
                          className="form-label"
                          style={{ color: "white" }}
                        >
                          CHA Contact Person
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="chaContactPerson"
                          value={formData.chaContactPerson}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="row g-4 mt-1">
                      <div className="col-md-4">
                        <label
                          className="form-label"
                          style={{ color: "white" }}
                        >
                          Surveyor
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="surveyor"
                          value={formData.surveyor}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-md-4">
                        <label
                          className="form-label"
                          style={{ color: "white" }}
                        >
                          Surveyor Contact Person
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="surveyorContactPerson"
                          value={formData.surveyorContactPerson}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-md-4">
                        <label
                          className="form-label"
                          style={{ color: "white" }}
                        >
                          Transporter
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="transporter"
                          value={formData.transporter}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="text-center mt-4">
                      <button
                        type="submit"
                        className="btn px-5"
                        style={{ backgroundColor: "#EC662C", color: "white" }}
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default DoForm;

